var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55348 1.37878H8.13292C9.26751 1.37878 10.1822 1.37878 10.9014 1.47562C11.6481 1.57595 12.2769 1.79062 12.7763 2.28995C13.103 2.61662 13.3077 2.9987 13.4384 3.43269L8.57982 5.54502C7.55257 5.99186 7.20139 6.13186 6.84322 6.13186C6.48504 6.13186 6.13388 5.99186 5.10662 5.54502L0.248047 3.43269C0.378714 2.9987 0.583465 2.61662 0.910132 2.28995C1.40947 1.79061 2.0383 1.57596 2.78502 1.47562C3.50427 1.37878 4.41884 1.37878 5.55348 1.37878Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0431663 4.70032C-5.34059e-08 5.32274 0 6.06357 0 6.9333V7.0243C0 8.1589 -2.67029e-08 9.07361 0.09625 9.7928C0.197167 10.5395 0.411837 11.1683 0.911164 11.6677C1.41049 12.1671 2.03933 12.3817 2.78605 12.482C3.5053 12.5788 4.41991 12.5788 5.55454 12.5788H8.13398C9.26857 12.5788 10.1833 12.5788 10.9025 12.482C11.6491 12.3817 12.278 12.167 12.7774 11.6677C13.2767 11.1684 13.492 10.5395 13.5923 9.7928C13.6885 9.07355 13.6885 8.15894 13.6885 7.0243V6.9333C13.6885 6.06355 13.6885 5.32274 13.6454 4.70032L8.963 6.73618C8.09617 7.11359 7.49359 7.37611 6.84426 7.37611C6.19493 7.37611 5.59242 7.11361 4.72551 6.73618L0.0431663 4.70032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footerMail.95c77279333d3287f1f934e527aa7b2f.svg";
export { ForwardRef as ReactComponent };